import {
  jb_burger_icon_css_default
} from "./chunk.3IHM47YW.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-burger-icon/jb-burger-icon.ts
var JbBurgerIcon = class extends Icon(r) {
  constructor() {
    super(...arguments);
    this.isOpen = false;
  }
  firstUpdated() {
    this.addEventListener("click", (e) => {
      e.preventDefault();
      this.dispatchEvent(new CustomEvent("burger-icon:clicked", { bubbles: true, composed: true }));
    });
  }
  render() {
    return ke`
      <div
        class=${Rt({
      "burger-icon": true,
      open: this.isOpen || false
    })}
      >
        <div class="bar-wrap">
          <div class="bar top"></div>
        </div>
        <div class="bar-wrap">
          <div class="bar middle"></div>
        </div>
        <div class="bar-wrap">
          <div class="bar bottom"></div>
        </div>
      </div>
    `;
  }
};
JbBurgerIcon.styles = [reset_css_default, jb_burger_icon_css_default];
__decorateClass([
  n({ type: Boolean })
], JbBurgerIcon.prototype, "isOpen", 2);
JbBurgerIcon = __decorateClass([
  customElement("jb-burger-icon")
], JbBurgerIcon);

export {
  JbBurgerIcon
};
